package com.milta.feature.team.domain.usecase

import com.milta.feature.team.domain.entity.TeamMembership
import com.milta.feature.team.domain.repository.TeamRepository

class GetMyTeamUseCase(private val repository: TeamRepository) {
    suspend operator fun invoke(): Result<List<TeamMembership>> = repository.getMyTeam()
}
